import React, { useEffect, useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { Form, Input, notification, Row, Spin } from 'antd';
import DF from 'DisplayFramework';
import {
  AddParMarketingLabel,
  ParMarketingLabel,
  UpdateParMarketingLabel,
} from 'services/assetconfig';
import FormInput from 'components/FormInput';
import ParListTemplateLancode from 'pages/Configuration/ParPrint/components/ParListTemplateLancode';
import AssetUpload from 'components/AssetUpload';
import SaveButton from 'components/SaveButtonTabsTop';
import { getAssetCatalogByID } from 'services/assetconfig';
import { useQuery } from 'react-query';

type MarketingLabelDetailProps = {
  ParMarketingLabel: any;
  ParMarketingResponse: any;
  idOrCreate: string;
  visible: boolean;
  list?: any;
  onSave: () => void;
};

const MarketingLabelDetail = ({
  ParMarketingLabel,
  ParMarketingResponse,
  idOrCreate,
  visible,
  list,
  onSave,
}: MarketingLabelDetailProps) => {
  const [form] = useForm();
  const [isCreate, setIsCreate] = useState(idOrCreate === 'create');
  const lancode = !isCreate ? idOrCreate : undefined;
  const [loading, setLoading] = useState(false);

  const { data: catalog, refetch } = useQuery(
    ['getAssetCatalogByID', { catalogid: lancode }],
    () =>
      getAssetCatalogByID({ catalogid: Number(lancode) }).then(
        (res) => res.data
      ),
    {
      enabled: !!lancode && !isCreate,
    }
  );
  const submit = (values: any) => {
    const data = {
      ...INITIAL_VALUES,
      ...values,
      picturebuttomlefturl: form.getFieldValue('picturebuttomlefturl'),
      picturebuttomrighturl: form.getFieldValue('picturebuttomrighturl'),
      picturecenterurl: form.getFieldValue('picturecenterurl'),
      picturemobileurl: form.getFieldValue('picturemobileurl'),
      picturetoplefturl: form.getFieldValue('picturetoplefturl'),
      picturetoprighturl: form.getFieldValue('picturetoprighturl'),
      pictureurl: form.getFieldValue('pictureurl'),
      mclabelPK: {
        lancode: ParMarketingResponse?.lancode,
        mcid: ParMarketingResponse?.mcid,
      },
      // catalogid: isNaN(Number(id)) ? null : Number(id),
    };

    if (idOrCreate === 'create') {
      AddParMarketingLabel({
        mcid: ParMarketingResponse?.mcid,
        request: data,
      }).then((response) => {
        if (response.code === '200') {
          setIsCreate(false);
          notification.success({
            description: response.description,
            message: response.message,
          });
          refetch();
          onSave();
        }
      });
    } else {
      UpdateParMarketingLabel({
        request: data,
        mcid: ParMarketingLabel?.mcid,
      }).then((response) => {
        if (response.code === '200') {
          notification.success({
            description: response.description,
            message: response.message,
          });
          refetch();
          onSave();
        }
      });
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...ParMarketingLabel,
    });
    // form.resetFields();
  }, [ParMarketingLabel, ParMarketingResponse, visible, form]);

  return (
    <DF.Provider pagcode="marketinglabeldetail">
      <Spin spinning={loading}>
        <Form
          form={form}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={INITIAL_VALUES}
          onFinish={submit}
          labelAlign="left"
          layout="vertical"
        >
          <div className="card-container">
            <Row justify="end" hidden={idOrCreate !== 'create'}>
              <SaveButton htmlType="submit" onClick={onSave} comcode="save" />
            </Row>
            <Row gutter={18}>&nbsp;</Row>

            <Row gutter={18}>
              <FormInput
                labelCol={{ span: 7 }}
                col
                md={6}
                name="lancode"
                rules={[{ required: true }]}
              >
                <ParListTemplateLancode
                  parcode="LANCODE"
                  listTemp={list ?? []}
                  doccode=""
                  disabled={idOrCreate === 'create' ? false : true}
                />
              </FormInput>
              <FormInput
                labelCol={{ span: 5 }}
                col
                md={12}
                name="mclabel"
                rules={[{ required: true }]}
              >
                <Input disabled={idOrCreate === 'create' ? false : true} />
              </FormInput>

              <FormInput
                labelCol={{ span: 2 }}
                col
                md={24}
                name="mcdescription"
              >
                <Input.TextArea
                  rows={5}
                  disabled={idOrCreate === 'create' ? false : true}
                />
              </FormInput>
            </Row>
            <Row>
              <FormInput
                col
                lg={8}
                onlylabel="picturebuttomlefturl"
                labelCol={{ span: '2px' }}
              >
                <AssetUpload
                  simpleUpload
                  form={form}
                  name="picturebuttomlefturl"
                  objectreference=""
                />
              </FormInput>

              <FormInput
                col
                lg={8}
                onlylabel="picturebuttomrighturl"
                labelCol={{ span: '2px' }}
              >
                <AssetUpload
                  simpleUpload
                  form={form}
                  name="picturebuttomrighturl"
                  objectreference=""
                />
              </FormInput>

              <FormInput
                col
                lg={8}
                onlylabel="picturecenterurl"
                labelCol={{ span: '2px' }}
              >
                <AssetUpload
                  simpleUpload
                  form={form}
                  name="picturecenterurl"
                  objectreference=""
                />
              </FormInput>

              <FormInput
                col
                lg={8}
                onlylabel="picturemobileurl"
                labelCol={{ span: '2px' }}
              >
                <AssetUpload
                  simpleUpload
                  form={form}
                  name="picturemobileurl"
                  objectreference=""
                />
              </FormInput>

              <FormInput
                col
                lg={8}
                onlylabel="picturetoplefturl"
                labelCol={{ span: '2px' }}
              >
                <AssetUpload
                  simpleUpload
                  form={form}
                  name="picturetoplefturl"
                  objectreference=""
                />
              </FormInput>

              <FormInput
                col
                lg={8}
                onlylabel="picturetoprighturl"
                labelCol={{ span: '2px' }}
              >
                <AssetUpload
                  simpleUpload
                  form={form}
                  name="picturetoprighturl"
                  objectreference=""
                />
              </FormInput>

              <FormInput
                col
                lg={8}
                onlylabel="pictureurl"
                labelCol={{ span: '2px' }}
              >
                <AssetUpload
                  simpleUpload
                  form={form}
                  name="pictureurl"
                  objectreference={form.getFieldValue('assetreference')}
                />
              </FormInput>
            </Row>
          </div>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

const INITIAL_VALUES: ParMarketingLabel = {
  mclabelPK: {
    lancode: '',
    mcid: 0,
  },
  mcdescription: '',
  mclabel: '',
  picturebuttomlefturl: '',
  picturebuttomrighturl: '',
  picturecenterurl: '',
  picturemobileurl: '',
  picturetoplefturl: '',
  picturetoprighturl: '',
  pictureurl: '',
};

export default MarketingLabelDetail;
